/*
 * Chat Messages
 *
 * This contains all the text for the cart/payment components.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  paymentType: {
    id: 'covert.containers.payment.field.paymentType',
    sid: 'paymentType',
  },
  cardType: {
    id: 'covert.containers.payment.field.cardType',
    sid: 'cardType',
  },
  cardNumber: {
    id: 'covert.containers.payment.field.cardNumber',
    sid: 'cardNumber',
  },
  cardNumberValidationEmpty: {
    id: 'covert.containers.payment.field.cardNumberValidationEmpty',
  },
  cardNumberInvalid: {
    id: 'covert.containers.payment.field.cardNumberInvalid',
  },
  expiryDate: {
    id: 'covert.containers.payment.field.expiryDate',
    sid: 'expiryDate',
  },
  expiryDatePlaceholder: {
    id: 'covert.containers.payment.field.expiryDatePlaceholder',
    sid: 'expiryDatePlaceholder',
  },
  expiryDateError: {
    id: 'covert.containers.payment.field.expiryDateError',
    sid: 'expiryDateError',
  },
  cvv: {
    id: 'covert.containers.payment.field.cvv',
    sid: 'cvv',
  },
  cvvValidationEmpty: {
    id: 'covert.containers.payment.field.cvvValidationEmpty',
  },
  cvvValidationMinLength: {
    id: 'covert.containers.payment.field.cvvValidationMinLength',
  },
  cvvPlaceholder: {
    id: 'covert.containers.payment.field.cvvPlaceholder',
  },
  cta: {
    id: 'covert.containers.payment.field.cta',
    sid: 'cta',
  },
})



// WEBPACK FOOTER //
// ./src/containers/Cart/Payment/messages.js